<template>
  <nav>
    <v-toolbar >
    <v-app-bar app color="secondary">
    <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <div class="d-flex-row justify-btw-end">
        <img
          class="logo"
          v-on:click="nav('home')"
          src="@/assets/Instaguard-Icon.png"
        />
        <div class="d-flex-row">
            <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-avatar size="46" style="position: relative; top: 5px;" v-bind="attrs"  v-on="on">
                <img v-bind:src="userInfo.profilePic"  />
              </v-avatar>
              <span v-bind="attrs" class="avatar-name" style="position: relative; top: 15px; font-weight: 600; margin-left: 8px; margin-right: 5px;" color="info" v-on="on">{{userInfo.name}}</span>
            </template>
                <v-list-item class="button2">
                <v-list-item-title v-on:click="nav('Users')" class="pointer">
                  Profile
                </v-list-item-title>
              </v-list-item>
              <v-divider />
                <v-list-item class="button2">
                  <v-list-item-title v-on:click="logout()" class="pointer">
                       Logout
                    </v-list-item-title>
                </v-list-item>
          </v-menu>

        </div>
      </div>
      </v-app-bar>
    </v-toolbar>

          <v-navigation-drawer v-model="drawer" :clipped="clipped" dark app color="secondary">
              <v-layout column align-center >
                   <v-flex class="mt-4 mb-4">
                        <v-avatar size="100">
                                <img src="@/assets/Instaguard-Icon.png" alt="">
                        </v-avatar>
                   </v-flex>
                        <!-- <h3 class="mt-1 text-center">CELLFUNDS</h3>
                        <p class="mt-1 text-center">POWERED BY COGNEETIV AI</p> -->
        <sequential-entrance fromLeft delay="8000">
                   <div class="text-center card-animate">
                     
                     
                     <v-btn
                       href="/#/userdashboard"
                       class="nav-button"
                       outlined
                       style="width: 85%; height:45px; border-radius:20px;"
                       color="primary"
                     >
                          
                        <v-avatar size="30">
                                <img src="@/assets/InterfaceIcon.png">
                        </v-avatar>
                     <div class="text"> Dashboard </div>
                     </v-btn>
                     <!-- <v-btn
                       href="/#/missioncontrol"
                       class="nav-button"
                       outlined
                       style="width: 85%; height:45px; border-radius:20px;"
                       color="primary"
                     >
                        <v-avatar size="30">
                                <img src="@/assets/ControlIcon.png">
                        </v-avatar>
                      <div class="text"> Control </div>
                     </v-btn>         -->

                     <!-- <v-btn
                   href="/#/dailybriefing"
                   class="nav-button"
                   outlined
                   style="width: 85%; height:45px; border-radius:20px;"
                   color="primary"
                 >
                      <v-avatar size="30">
                              <img src="@/assets/briefing.png">
                      </v-avatar>
                 <div class="text">  Briefing </div>
                 </v-btn> -->
                 <v-btn
                       href="/#/leads"
                       class="nav-button"
                       outlined
                       style="width: 85%; height:45px; border-radius:20px;"
                       color="primary"
                     >
                        <v-avatar size="30">
                                <img src="@/assets/LeadsIconv3.png">
                        </v-avatar>
                      <div class="text"> Leads </div>
                     </v-btn>
                     <!-- <v-btn
                       href="/#/sales"
                       class="nav-button"
                       outlined
                       style="width: 85%; height:45px; border-radius:20px;"
                       color="primary"
                     >
                        <v-avatar size="30">
                                <img src="@/assets/SalesIcon.png">
                        </v-avatar>
                      <div class="text"> Sales </div>
                     </v-btn> -->
                     <v-btn
                   href="/#/proposals"
                   class="nav-button"
                   outlined
                   style="width: 85%; height:45px; border-radius:20px;"
                   color="primary"
                 >
                        <v-avatar size="30">
                                <img src="@/assets/InvoiceIconNEW3.png">
                        </v-avatar>
                  <div class="text"> Proposals </div>
                 </v-btn>
                     <v-btn
                       href="/#/accounts"
                        class="nav-button"
                        outlined
                        style="width: 85%; height:45px; border-radius:20px;"
                        color="primary"
                      >
                        <v-avatar size="30">
                                <img src="@/assets/AccountIconv3.png">
                        </v-avatar>
                        <div class="text"> Accounts </div>
                      </v-btn>
                      <v-btn
                       href="/#/contacts"
                        class="nav-button"
                        outlined
                        style="width: 85%; height:45px; border-radius:20px;"
                        color="primary"
                      >
                        <v-avatar size="30">
                                <img src="@/assets/CustomerIconNEW3.png">
                        </v-avatar>
                        <div class="text"> Contacts </div>
                      </v-btn>
                     <!-- <v-btn
                       href="/#/sales"
                       class="nav-button"
                       outlined
                       style="width: 85%; height:45px; border-radius:20px;"
                       color="primary"
                     >
                        <v-avatar size="30">
                                <img src="@/assets/SalesIcon.png">
                        </v-avatar>
                      <div class="text"> Sales </div>
                     </v-btn> -->
                     <!-- <v-btn
                       href="/#/opportunities"
                       class="nav-button"
                       outlined
                       style="width: 85%; height:45px; border-radius:20px;"
                       color="primary"
                     >
                        <v-avatar size="30">
                                <img src="@/assets/CustomerIconv2.png">
                        </v-avatar>
                      <div class="text"> Opportunity </div>
                     </v-btn> -->
                 

                 <!-- <v-btn
                   href="/#/leads"
                   class="nav-button"
                   outlined
                   style="width: 85%; height:45px; border-radius:20px;"
                   color="primary"
                 >
                        <v-avatar size="30">
                                <img src="@/assets/LeadsIconv3.png">
                        </v-avatar>
                  <div class="text"> Leads </div>
                 </v-btn> -->
                 <v-btn
                   href="/#/tasks"
                   class="nav-button"
                   outlined
                   style="width: 85%; height:45px; border-radius:20px;"
                   color="primary"
                 >
                        <v-avatar size="30">
                                <img src="@/assets/TaskIcon.png">
                        </v-avatar>
                  <div class="text"> Tasks  </div>
                 </v-btn>
                 <v-btn
                   href="/#/notes"
                   class="nav-button"
                   outlined
                   style="width: 85%; height:45px; border-radius:20px;"
                   color="primary"
                 >
                        <v-avatar size="30">
                                <img src="@/assets/ResearchIcon.png">
                        </v-avatar>
                  <div class="text"> Notes  </div>
                 </v-btn>
                 <!-- <v-btn
                   href="/#/calendar"
                    class="nav-button"
                    outlined
                    style="width: 85%; height:45px; border-radius:20px;"
                    color="primary"
                  >
                        <v-avatar size="30">
                                <img src="@/assets/CalendarIcon.png">
                        </v-avatar>
                        <div class="text"> Calendar </div>
                  </v-btn> -->
                 <!-- <v-btn
                   href="/#/map"
                    class="nav-button"
                    outlined
                    style="width: 85%; height:45px; border-radius:20px;"
                    color="primary"
                  >
                        <v-avatar size="30">
                                <img src="@/assets/InterfaceIcon3.png">
                        </v-avatar>
                        <div class="text"> Map </div>
                 </v-btn>
                 <v-btn
                       href="/#/interface"
                       class="nav-button"
                       outlined
                       style="width: 85%; height:45px; border-radius:20px;"
                       color="primary"
                     >
                      
                        <v-avatar size="30">
                                <img src="@/assets/InterfaceIcon2.png">
                        </v-avatar>
                      <div class="text"> Interface</div>
                   </v-btn>    -->
 
                 <br />                 
<v-divider></v-divider>
                 <br />
                 <br />
                            <ThemeChanger />
                   </div>
               </sequential-entrance>
              </v-layout>

          </v-navigation-drawer>


  </nav>
</template>
<script>
import ThemeChanger from '@/components/ThemeChanger.vue';

export default {
  name: "Nav",
  data: () => ({
    fav: true,
    menu: false,
    message: false,
    hints: true,
    drawer: false,
    item: 1,
    items: [],
    userInfo:{}
  }),
  components: {
    ThemeChanger,
  },
  mounted() {
       let profile = JSON.parse(localStorage.getItem("currentUser")) 
        this.userInfo=profile;
  },
  methods: {
    nav(path) {
      this.$router.push({ name: path });
      
    },
     logout(){
      localStorage.clear();
        this.$router.push({ name: "Login" });
    }
  },
};
</script>

<style scoped>

.logo {
  width: 60px;
}
.nav {
  background: #bbd64d;
}
.justify-btw-end {
  width: 100%;
  justify-content: space-between;
}
.avatar-name {
  position: relative;
  top: 10px;
  font-weight: 600;
  font-size: 16px;
  margin-left: 8px;
  margin-right: 5px;
}
.pointer{
  cursor: pointer;
}

.text{
  font-size: 16px;
  font-weight: 400;
  margin: 20px;
}
.button2 {
  background: rgba(16, 22, 58, 0.0);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  width: 160px;
}

.button2:hover {
  background: rgba(16, 22, 58, 0.3);
	animation: glow 1800ms ease-out infinite alternate;
	border-color: #393;
	box-shadow: 0 0 5px rgba(0,255,0,.2), inset 0 0 5px rgba(0,255,0,.1), 0 2px 0 #000;
  border-radius: 30px;
}

.card-animate {
  animation-name: slideleft;
  /* position: relative;
  position-fromtop: 100px; */
  animation-duration: 2.75s;
  transition: opacity 1s Elastic.easeIn;
}
.card-animate-out {
  animation-name: slideright;
  /* position: relative; */
  /* position-fromtop: 100px; */
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeOut;
}
/* Standard syntax */
@keyframes slideleft {
  0% {
    left: -800px;
    top: -40px;
    opacity: 0;
  }
  100% {
    left: 92px;
    top: -40px;
    opacity: 1;
  }
}
/* Standard syntax */
@keyframes slideright {
  0% {
    left: 800px;
    top: 0px;
  }
  100% {
    left: 0px;
    top: 0px;
  }
}
@keyframes slidetop {
  0% {
    bottom: -1000px;
    top: 0px;
  }
  100% {
    bottom: 10px;
    top: 0px;
  }
}
@keyframes slidebottom {
  0% {
    bottom: 1000px;
    top: 0px;
  }
  100% {
    bottom: 10px;
    top: 0px;
  }
}


.nav-button{
  background: #131f250c;
  text-decoration: none !important;
  width: 100%;
  justify-content: left;
  margin: 10px;
  font-family: Arial, Helvetica, sans-serif;
  border-radius: 60px;
  animation: glow3 1800ms ease-out infinite alternate;
  }
  @keyframes glow3 {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 4px rgba(90, 128, 191, 0.1),
        inset 0 0 6px rgba(90, 128, 191, 0.2), 0 1px 0 #000;
    }

    100% {
      border-color: #11ece5;
      box-shadow: 0 0 6px rgba(90, 128, 191, 0.2),
        inset 0 0 10px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
    }
  }
.space5 {
  height: 35px;
}

.logo {
  width: 45px;
}
.nav {
  background: rgb(77, 74, 74);
}
.justify-btw-end {
  width: 100%;
  justify-content: space-between;
}
.avatar-name {
  position: relative;
  top: 10px;
  font-weight: 600;
  margin-left: 8px;
  margin-right: 5px;
}

.navi {
  background: #002439;
  transition: all 0.5s ease-in-out;
}

.navi {
  background: #304057;
  transition: scale(1.1);
}

.button {
  background: #304057c9;
  border-radius: 80px;
  padding: 20px;
  margin-block: 10px;
  width: 100px;
  border: outline;
  opacity: 0.9;
  cursor: pointer;
  margin-left: 0px;
  margin-right: auto;
  left: 0px;
  right: 0px;
  align: center;
  outline-color: #5a80bf;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
    inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
  outline: none;
  }
  @keyframes glow {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
        inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
    }

    100% {
      border-color: #11ece5;
      box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
        inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }

@media only screen and (max-width: 600px) {
  
.button {
  border-radius: 40px;
  padding: 20px;
  width: 10px;
  border: outline;
  opacity: 0.9;
  cursor: pointer;
  margin-left: 0px;
  margin-right: auto;
  left: 0px;
  right: 0px;
  align: center;
  outline-color: #5a80bf;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
    inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
  outline: none;
  }
  @keyframes glow {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
        inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
    }

    100% {
      border-color: #11ece5;
      box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
        inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }

}

</style>
